// extracted by mini-css-extract-plugin
export default {"container":"Dashboard-module--container--mXeL4","cards":"Dashboard-module--cards--MGIyc","cardsmobile":"Dashboard-module--cardsmobile--4KEWP"};